import type { UploadAttachmentResponse } from "../../../../components/return-form/uploadAttachment";
import { baseUrl } from "../../../../libs/client/baseUrl";
import { customFetch } from "../../rpc";

/**
 * mypage 経路の添付アップロード実装。`POST /mypage/api/me/uploads` (multipart) を投げる。
 * session cookie / CSRF は `customFetch` (`rpc.ts`) が付与する。共有 ReturnWizard に
 * `uploadAttachment` prop として注入する (= 認証・エンドポイント差分を mypage 側に閉じ込める)。
 */
export const uploadReturnAttachmentViaMyPage = async (
  file: File,
): Promise<UploadAttachmentResponse> => {
  const form = new FormData();
  form.append("file", file);
  form.append("namespace", "returns");
  const res = await customFetch(baseUrl("/mypage/api/me/uploads"), {
    method: "POST",
    body: form,
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { message?: unknown };
    return {
      ok: false,
      message:
        typeof body?.message === "string"
          ? body.message
          : `アップロードに失敗しました (HTTP ${res.status})`,
    };
  }
  return (await res.json()) as UploadAttachmentResponse;
};
